(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDialogController', PaperPriceDialogController);

    PaperPriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaperPrice', 'YieldCurveResults'];

    function PaperPriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaperPrice, YieldCurveResults) {
        var vm = this;

        vm.paperPrice = entity;
        vm.clear = clear;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paperPrice.id !== null) {
                PaperPrice.update(vm.paperPrice, onSaveSuccess, onSaveError);
            } else {
                PaperPrice.save(vm.paperPrice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:paperPriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
